export default __webpack_public_path__ + "images/GX.57fc249.png";